import BaseApi from "@/common/api/BaseApi";
import InventoryStoresCollection from "@/common/collections/InventoryStoresCollection";
import { callApiV2 } from "@/lib/config/Api";
import {
	FilterStoreWithProductVariant,
	InventoryStoresCollectionJson,
} from "@/types/Inventories.type";
import Helper from "@/utils/helper";

export async function getListStoreWithProductVariant(
	filters?: FilterStoreWithProductVariant
) {
	const apiParams = Helper.convertFilterToParams(filters || {});

	const response = await callApiV2<InventoryStoresCollectionJson>(
		`/inventories/public/store${apiParams}`,
		"get"
	);

	return response;
}
